import { brandApi } from "../lib/axios";
import type { ProductRecurring, ProductsAnalytics } from "@/types/products-analytics";

class ProductService {
  async findAll(cursor?: string, limit: number = 20) {
    const response = await brandApi.get("/products/find-all", {
      params: { cursor, limit },
    });
    return response.data;
  }

  async findById(id: string) {
    const response = await brandApi.get(`/products/${id}`);
    return response.data;
  }

  async getVariants(productId: string, cursor?: string, limit: number = 20) {
    const response = await brandApi.get(`/products/${productId}/variants`, {
      params: { cursor, limit },
    });
    return response.data;
  }

  async getSalesMonthly(productId: string) {
    const response = await brandApi.get(`/products/${productId}/sales-monthly`);
    return response.data;
  }

  async getAffiliateSales(
    productId: string,
    page: number = 1,
    limit: number = 10
  ) {
    const response = await brandApi.get(
      `/products/${productId}/affiliate-sales`,
      {
        params: { page, limit },
      }
    );
    return response.data;
  }

  async getCampaignSales(
    productId: string,
    page: number = 1,
    limit: number = 10
  ) {
    const response = await brandApi.get(
      `/products/${productId}/campaign-sales`,
      {
        params: { page, limit },
      }
    );
    return response.data;
  }

  /** Products > Analytics for one period (7, 30 or 90 days). */
  async getAnalytics(days: number): Promise<ProductsAnalytics> {
    const response = await brandApi.get<ProductsAnalytics>("/analytics/brand/products", {
      params: { days },
    });
    return response.data;
  }

  /** The Recurring tab on one product's insights page. */
  async getRecurring(productId: string): Promise<ProductRecurring> {
    const response = await brandApi.get<ProductRecurring>(
      `/analytics/brand/products/${encodeURIComponent(productId)}/recurring`
    );
    return response.data;
  }
}

export const productService = new ProductService();
